export const CONTENTFUL_CONTENT_DELIVERY_TOKEN =
  'eQtyFzGnSvemwasqdmKSrRnYPxXOuZfDD40VCtClqFU';

export const STRIPE_PUBLISHABLE_KEY =
  'pk_live_51I6GChBOdzcUHfTae49YGQEdpwZHd20E6SKmzcLMvGboyeIfVR0HO8GWT0dySMN94OXbCCSMIhdx7PAybat7IGSV00eSBF3OVs';

export const STRIPE_PUBLISHABLE_KEY_TEST =
  'pk_test_51I6GChBOdzcUHfTacNBn0LSRv7KxKBuTHPF9PDfhGLCiXbhAg7ar0v5RvfDnt4GTcAwqynWqKFtCOeI02VpABFxx00B6jswLmM';

export const MAP_GL_KEY =
  'pk.eyJ1Ijoia3Jpc3RmYWxscm8iLCJhIjoiY2tidDV4ZDcyMDY1NzJzbGlpMmg5dmIxYiJ9.7jPPwagATmB0MtZc8jQsJA';
